import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const StoreListQuery = gql`
    query($domain: String!) {
        stores(domain: $domain) {
            id
            createdAt
            name
            slug
            title
            subtitle
            description
            address
            phone
            email
            openingTimes
            storePhoto
            storeBackground
            storeVirtualView
            storePhotogallery
            priority
        }
        languages {
            id
            value
        }
    }
`;

const CreateStoreMutation = gql`
    mutation($store: CreateStoreInput!) {
        createStore(store: $store) {
            id
        }
    }
`;

const UpdateStoreMutation = gql`
    mutation($id: String!, $store: UpdateStoreInput!) {
        updateStore(id: $id, store: $store) {
            id
        }
    }
`;

const DeleteStoreMutation = gql`
    mutation($id: String!) {
        deleteStore(id: $id) {
            id
        }
    }
`;

interface IInputProps {
    children?: any;
    domain: string;
    storeId?: string;
}

interface Response {
    data: any;
}

class GetStoreQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
    render() {
        const { stores, createStore, updateStore, deleteStore }: any = this.props;
        return this.props.children({
            stores,
            createStore,
            updateStore,
            deleteStore
        });
    }
}

export default compose(
    graphql<IInputProps, Response>(StoreListQuery, {
        name: 'stores',
        options: props => ({
            variables: { domain: props.domain }
        })
    }),
    graphql<IInputProps, Response>(CreateStoreMutation, {
        name: 'createStore'
    }),
    graphql<IInputProps, Response>(UpdateStoreMutation, {
        name: 'updateStore'
    }),
    graphql<IInputProps, Response>(DeleteStoreMutation, {
        name: 'deleteStore'
    })
)(GetStoreQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Stores/Stores.tsx